// Categories.js
import React from 'react';
import { BringzzText, BringzzIcon } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import classNames from 'classnames';

const Categories = ({ categories: allCategories, setSearchData, loadLocalPharmacies, callBack }) => {
    const { navigate } = useNavigation();

    if (!allCategories || allCategories.length === 0) {
        return null;
    }

    const handleCategoryClick = async (category, index) => {
        // Navigate to dedicated pages for Local Pharmacies and Companies
        if (category.isPharmacyList || category.shortName?.includes('Pharmacies') || category.shortName?.includes('pharmacies')) {
            navigate('/search/local-pharmacies');
            return;
        }
        
        if (category.shortName?.includes('Companies') || category.shortName?.includes('companies')) {
            navigate('/search/companies');
            return;
        }
        
        setSearchData({
            method: "category",
            value: category.shortName,
            results: category.items || []
        });
        callBack && callBack();
    };

    return (
        <div className='py-2 px-6 mx-2 bg-white rounded-xl'>
            {allCategories.map((category, index) => (
                <div key={index}>
                    <div className={classNames(
                        'flex items-center h-12 justify-between cursor-pointer',
                        index !== allCategories.length - 1 && 'border-b'
                    )}
                        onClick={() => handleCategoryClick(category, index)}
                    >
                        <div className='flex space-x-3 items-center'>
                            {category.icon}
                            <BringzzText tag='h3' className='font-normal'>{category.shortName}</BringzzText>
                        </div>
                        <BringzzIcon 
                            size="16" 
                            icon="IconChevronRight" 
                            folder="LineIcons" 
                        />
                    </div>

                </div>
            ))}
        </div>
    );
};

export default Categories;